import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  };
  const logout = () => { localStorage.removeItem(TOKEN_KEY); setUser(false); };
  const canEdit = user && ["super_admin", "editor"].includes(user.role);

  return <AuthContext.Provider value={{ user, login, logout, canEdit, canPublish: !!user?.can_publish }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
